import { LOGIN_PATH } from 'constants/navigation';
import { getCurrentUrl } from 'utils/window';

class SocialNetworks {
  courseTitle: any;
  authStorageUrl: any;
  location: any;

  constructor(courseTitle: any, authStorageUrl: any) {
    this.courseTitle = courseTitle;
    this.authStorageUrl = authStorageUrl;
    this.location = `${getCurrentUrl()}#${LOGIN_PATH}`;
  }

  getAuthLink(socialNetwork: any) {
    return `${this.authStorageUrl}/api/auth/${socialNetwork}?callbackLink=${encodeURIComponent(
      this.location
    )}&callbackTitle=${encodeURIComponent(this.courseTitle)}`;
  }
}

export default SocialNetworks;
